module.exports = {
  qqgdscpjypt: "全球高端水产品交易平台（深圳国际金枪鱼交易有限公司）",
  kjmy: "跨境贸易",
  pkfw: "品控服务",
  ccfw: "仓储服务",
  pzzx: "交割中心",
  lliaojiexiangq: "了解详情",
  title3: "量身定制您的战略规划，小到每个细节",
  title4: "高效通关",
  title5: "可提供先货后税的服务助力国内客户快速通关",
  title6: "保证链条业务效率",
  title7: "无忧采购",
  title8: "引入金融机构助力国内买家提供采购融资服务",
  title9: "提高采购能力和助力扩大业务规模",
  title10: "流程风控",
  title11: "根据协议规定的流程作业",
  title12: "任何超出的流程都将被系统禁止操作",
  title13: "交易保障更放心",
  title14: "汇率保值",
  title15: "通过银行代客锁汇",
  title16: "控制汇率风险",
  title17: "做好采购成本管理",
  title18: "价格管理",
  title19: "通过大数据分析产品周期及市场情况",
  title20: "进行预判并自动调整垫资比例",
  title21: "全链条解决方案",
  title22: "让您全程无忧",
  title23: "订单洽谈",
  title24: "集中采购",
  title25: "单据文件",
  title26: "支付/融资结算",
  title27: "跨境物流",
  title28: "智慧通关",
  title29: "财税咨询服务",
  title30: "仓储代替",
  title31: "物流运输",
  title32: "加工服务",
  title33: "无忧采购，助力客户优化现金流",
  title34: "资金更灵活，采购更轻松，成本更确定",
  title35: "尾款垫付",
  title36:
    "可以为国内符合准入条件的下游客户垫付尾款，缓解备货压力，扩大业务规模，助力其抢占国内市场份额",
  title37: "灵活用款",
  title38: "随借随还，资金随货物的采销进行借还",
  title39: "外汇保值",
  title40: "引入金融机构为国内下游客户提供锁汇等服务，控制采购成本",
  title41: "快捷体验",
  title42: "线上服务，按订单用款和还款，业务清晰，国内下游客户接单更轻松",
  title43: "服务范围",
  lang1: "品控服务是指对水产品进行品质控制和监督的服务。",
  lang2: "旨在确保水产品的品质符合相关标准和要求。",
  lang3:
    " 通过对产品质量的监控和控制，以确保水产品的新鲜度、外观等指标符合质量标准。",
  lang4: "服务内容",
  lang5: "原料检验",
  lang6:
    "对水产品原料进行检验，包括鱼类、虾类、贝类等，以确保原料的质量和安全性。",
  lang7: "过程监控",
  lang8:
    "监控水产品的生产过程，包括加工、冷冻、包装等环节，以确保每个环节符合质量标准和操作规程。",
  lang9: "质量抽检",
  lang10:
    "对冻品进行定期的质量抽检，包括外观、口感、营养成分等方面的检测，以确保产品的品质符合标准。",
  lang11: "标签和包装检查",
  lang12:
    "检查水产品的标签和包装，确保产品的标识和包装符合法规要求，提供正确的产品信息和保护产品的完整性。",
  lang13: "供应链管理",
  lang14:
    "对水产品的供应链进行管理和监控，包括供应商评估、物流管理等，以确保产品的来源和去向可追溯，并保证供应链的稳定性和可靠性。",
  lang15: "服务优势",
  lang16: "品控服务可以确保水产品的品质符合相关标准和要求",
  lang17: "减少产品质量问题和食品安全风险",
  lang18: "通过品控服务，可以为企业建立良好的品牌形象和声誉",
  lang19: "提升消费者对产品的信任度和忠诚度",
  lang20: "品控服务可以提高水产品的市场竞争力",
  lang21: "满足消费者对高品质产品的需求，增加产品的销售和市场份额",
  lang22: "品控服务可以提供数据分析和改进建议，帮助企业了解产品质量",
  lang23: "状况和市场需求，优化产品质量和生产流程，实现持续改进",
  delivery1: "全球交割仓",
  delivery2: "为交易平台的高端水产品提供全球化的交割服务",
  delivery3:
    "全球交割仓包括交易平台自有的交割仓和与国内外合作伙伴共建的交割仓，涵盖了高端水产品主要产区和消费区的重要城市和港口。",
  delivery4: "国际化、规范化、专业化、品牌化",
  delivery5:
    "全球交割仓的建设和发展，为交易平台的高端水产品提供更加便利、高效、安全、可靠的交割服务，扩大交易平台的国际影响力和知名度。",
  delivery6: "加强与国内外合作伙伴的合作",
  delivery7:
    "目前，交易平台已经与万纬冷链建立战略合作伙伴关系。未来，交易平台将继续加强与国内外合作伙伴的合作，扩大全球交割仓的网络和覆盖范围，提高交割服务的质量和效率，为客户提供更加优质的服务和更加便利的交割方式。",
  delivery8: "覆盖主要沿海集散地城市",
  delivery9:
    "覆盖国内主要沿海集散地城市：大连、青岛、宁波、舟山、福州、深圳等；覆盖中国及东亚地区：东京、釜山、曼谷等；",
  delivery10:
    "全球高端水产品交易平台全球交割仓是指交易平台在全球范围内建立的交割仓库网络，旨在为交易平台的高端水产品提供全球化的交割服务。全球交割仓包括交易平台自有的交割仓和与国内外合作伙伴共建的交割仓，涵盖了高端水产品主要产区和消费区的重要城市和港口。",
  delivery11:
    "全球交割仓的建设和发展，是交易平台实现“国际化、规范化、专业化、品牌化”的发展战略的重要组成部分。全球交割仓的建设和发展，可以为交易平台的高端水产品提供更加便利、高效、安全、可靠的交割服务，扩大交易平台的国际影响力和知名度。",
  delivery12:
    "目前，交易平台已经与万纬冷链建立战略合作伙伴关系。未来，交易平台将继续加强与国内外合作伙伴的合作，扩大全球交割仓的网络和覆盖范围，提高交割服务的质量和效率，为客户提供更加优质的服务和更加便利的交割方式。",
  delivery13: "交割仓网络阶段建设发展规划：",
  delivery14:
    "第一阶段：覆盖国内主要沿海集散地城市：大连、青岛、宁波、舟山、福州、深圳等；",
  delivery15: "第二阶段：覆盖中国及东亚地区：东京、釜山、曼谷等；",
  delivery16: "第三阶段：覆盖一带一路国家主要集散地城市。",
  service6: "物流服务",
  title88: "冷运仓储",
  title89: "提供货物冷库存储、分拣、包装、配送、信息流转等一体化冷运服务",
  title90: "多温区管控",
  title91: "多温区存储",
  title92: "全天24H温度监控，过程可溯",
  title93: "覆盖范围广",
  title94: "通过各仓辐射范围",
  title95: "干、配可覆盖中国内地大部分地区",
  title96: "多品类服务",
  title97: "整进零出",
  title98: "可提供小批次多品类操作服务",
  title99: "全国分仓",
  title100: "提供中国内地分仓服务",
};



// WEBPACK FOOTER //
// ./src/lang/zh.js